var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotEqual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6566 3.10834C13.0111 3.32268 13.1246 3.78378 12.9103 4.13822L11.7843 6.00011H15C15.4142 6.00011 15.75 6.3359 15.75 6.75011C15.75 7.16433 15.4142 7.50011 15 7.50011H10.8772L9.06297 10.5001H15C15.4142 10.5001 15.75 10.8359 15.75 11.2501C15.75 11.6643 15.4142 12.0001 15 12.0001H8.15585L6.56047 14.6382C6.34613 14.9927 5.88503 15.1062 5.53059 14.8919C5.17615 14.6775 5.06258 14.2164 5.27693 13.862L6.40289 12.0001H3C2.58579 12.0001 2.25 11.6643 2.25 11.2501C2.25 10.8359 2.58579 10.5001 3 10.5001H7.31001L9.12424 7.50011H3C2.58579 7.50011 2.25 7.16433 2.25 6.75011C2.25 6.3359 2.58579 6.00011 3 6.00011H10.0314L11.6267 3.362C11.8411 3.00756 12.3022 2.89399 12.6566 3.10834Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotEqual);
export default __webpack_public_path__ + "static/media/not_equal.406d779f91a9d03ac8ee43870cb998b9.svg";
export { ForwardRef as ReactComponent };